// extracted by mini-css-extract-plugin
export default {"cls1":"PaperSelector-cls1_ciB","cls2":"PaperSelector-cls2_PNw PaperSelector-cls1_ciB"};